import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';

/** @category Banking */
export function useTransferHistory(profileId) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  return useQuery(tokenizedApi.banking.transfersQuery(profileId))?.data || [];
}
